module.exports = __webpack_public_path__ + "img/layout-escuro.56d56a35.svg";